import React, { useEffect, useState } from 'react'
import Order from './order'
import { containerIprops } from './orderinterface'
import { ICartContextType } from '../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import { useCartContext } from '../../ShoppingCart/shoppingcart';
import helperfunctions from "../../../utils/helperfunctions";
import partsService from "../../../services/partsservice";
import { useSelector } from 'react-redux';
import { selectors as headerSelector } from '../../../state/features/header';

const OrderContainer = (props: containerIprops) => {

  const { stepperDetails, cartsDetails }: ICartContextType = useCartContext();
  const [orderSummaryData, setOrderSummaryData] = useState({ loading: false, data: {} })

  const {
    headercurrentuser,
  }: any = useSelector(
    state => ({
      headercurrentuser: headerSelector.currentuser(state),
    })
  );

  const getOrderSummaryDetails = async () => {
    try {
      setOrderSummaryData({ loading: true, data: [] });
      const reqBody = {
        cartId: cartsDetails?.cart?.cartId,
        userAadId: headercurrentuser?.azureADId ?? '',
      }
      const response: any = await partsService.getOrderSummaryDetails(reqBody)
      if (response?.isSuccess) {
        if (!stepperDetails?.order?.splInstruction) {
            const orderObj = { splInstruction: response?.data?.specialInstructions ?? '' };
            if (props?.updateStepperDetails) {
                props.updateStepperDetails({ ...stepperDetails, order: orderObj })
            }
        }
        setOrderSummaryData({ loading: false, data: response?.data ?? {} });
      } else {
        setOrderSummaryData({ loading: false, data: [] });
        helperfunctions.showErrorMessage(response?.msg);
      }
    } catch (error) {
      setOrderSummaryData({ loading: false, data: [] });
      helperfunctions.showErrorMessage(error);
    }
  }

  useEffect(() => {
    getOrderSummaryDetails();
  }, []);

    useEffect(() => {
        if (props.isPromoChanges) {
            getOrderSummaryDetails();
        }
    }, [props.isPromoChanges]);

  const updateSplInstruction = (splInstruction: string) => {
      const orderObj = { splInstruction };
      if (props?.updateStepperDetails) {
          props.updateStepperDetails({ ...stepperDetails, order: orderObj });
      }
  }

  const onSplInstructionChange = (value: string) => {
    const currentSplInst = stepperDetails?.order?.splInstruction ?? '';
    let splInstruction = '';
    if (value?.length <= 512) {
      splInstruction = value ?? '';
      updateSplInstruction(splInstruction);
    } else {
      if (currentSplInst?.length != 512) {
        const truncatedValue = value.substring(0, 512);
        splInstruction = truncatedValue;
      } else {
        splInstruction = currentSplInst;
      }
      updateSplInstruction(splInstruction);
    }
  }

  return (
      <Order
      changeindexthree={props.changeindexthree}
      changeindextwo={props.changeindextwo}
      changeindexone={props.changeindexone}
      onSplInstructionChange={onSplInstructionChange}
      stepperDetails={stepperDetails}
      orderSummaryData={orderSummaryData}
      scrollToDiv={props?.scrollToDiv}
    />
  )
}

export default OrderContainer;